import { FC } from "react"

import CardCollapseButton from "../generic/buttons/CardCollapseButton"

interface IProps {
  title: string

  classNames?: string
  collapsed?: boolean
  onClick?: () => void
}

const Card: FC<IProps> = ({ children, title, onClick, collapsed }) => {
  return (
    <section className="ocs-fields-card">
      {collapsed !== undefined && (
        <CardCollapseButton
          onClick={onClick}
          title={title}
          collapsed={collapsed}
        />
      )}

      <div>{children}</div>
    </section>
  )
}

export default Card
